var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 14.3123H11.2621V10.6037C11.2621 9.71937 11.2463 8.58093 10.0291 8.58093C8.79431 8.58093 8.60538 9.5445 8.60538 10.5393V14.3121H6.23475V6.68571H8.51056V7.72794H8.54244C8.77019 7.33893 9.09931 7.01891 9.49474 6.80197C9.89017 6.58502 10.3371 6.47927 10.7879 6.49598C13.1908 6.49598 13.6338 8.07474 13.6338 10.1286L13.6328 14.3123ZM3.55975 5.6433C2.79994 5.64342 2.18387 5.02822 2.18375 4.26925C2.18362 3.51027 2.79944 2.89489 3.55925 2.89476C4.31906 2.89458 4.93512 3.50977 4.93525 4.26875C4.93532 4.63322 4.79044 4.9828 4.53248 5.24057C4.27453 5.49835 3.92463 5.64321 3.55975 5.6433ZM4.74512 14.3124H2.37194V6.68571H4.74506V14.3123L4.74512 14.3124ZM14.8146 0.695499H1.18069C0.536312 0.688257 0.007875 1.20388 0 1.84754V15.5233C0.007625 16.1673 0.536 16.6834 1.18062 16.6766H14.8146C15.4606 16.6846 15.9911 16.1685 16 15.5233V1.84648C15.9908 1.20157 15.4603 0.68601 14.8146 0.694438",
    fill: "#0A66C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.356ae2d9ed3d855f5e068e6c5dd52d69.svg";
export { ForwardRef as ReactComponent };